import Swal from 'sweetalert2';

/**
 * クレジットカード登録の連続失敗によるロック処理
 *
 * 3回失敗すると30分間カード登録をロックする（MEMORUの PaymentAdd.vue と同じ仕様）。
 * 3Dセキュア認証はフルページ遷移を挟むため、PaymentRegister.vue と
 * 3dSecure.vue の両方から利用できるようにクッキーで状態を保持する。
 */

const LOCK_COOKIE = 'register_locked';
const RETRY_COUNT_COOKIE = 'retry_count';
const MAX_RETRY_COUNT = 3;
const LOCK_MINUTES = 30;

// クッキーを取得するヘルパー関数
const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
  return null;
};

// クッキーを設定するヘルパー関数（分単位の有効期限）
const setCookie = (name: string, value: string, minutes: number) => {
  const date = new Date();
  date.setTime(date.getTime() + (minutes * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Lax`;
};

/**
 * ロック中かどうか
 */
export const isCardRegisterLocked = (): boolean => getCookie(LOCK_COOKIE) != null;

/**
 * ロック中であることを表示する
 */
export const showCardRegisterLocked = () => Swal.fire({
  icon: 'error',
  title: '操作がロックされています',
  text: `連続で失敗したため、${LOCK_MINUTES}分間登録できません。しばらく経ってからお試しください。`,
});

/**
 * 失敗回数を1回増やし、結果を表示する。3回に達したらロックする。
 * @param title 失敗時のタイトル
 * @param text 失敗時の本文（残り回数の案内の前に表示する）
 */
export const countCardRegisterFailure = (title: string, text?: string) => {
  const currentCount = parseInt(getCookie(RETRY_COUNT_COOKIE) || '0', 10) + 1;

  if (currentCount >= MAX_RETRY_COUNT) {
    // 3回失敗したら、30分間のロッククッキーをセット
    setCookie(LOCK_COOKIE, 'true', LOCK_MINUTES);
    setCookie(RETRY_COUNT_COOKIE, '', -1);
    return Swal.fire({
      icon: 'error',
      title: '登録に連続で失敗しました',
      text: `セキュリティのため、${LOCK_MINUTES}分間カード登録がロックされます。`,
    });
  }

  // 3回未満なら、カウントを更新（30分間有効）
  setCookie(RETRY_COUNT_COOKIE, String(currentCount), LOCK_MINUTES);
  const remainingText = `あと ${MAX_RETRY_COUNT - currentCount} 回失敗すると${LOCK_MINUTES}分間登録できなくなります。`;
  return Swal.fire({
    icon: 'error',
    title,
    text: text ? `${text}\n${remainingText}` : remainingText,
  });
};

/**
 * 失敗回数をリセットする（登録成功時）
 */
export const resetCardRegisterFailure = () => {
  setCookie(RETRY_COUNT_COOKIE, '', -1);
};
